<template>
  <div class="login">
    <img src="@/assets/images/img_bg@3x.png" class="back-ground" alt="">
    <van-form ref="loginForm" class="login-form" @submit="handleLoginSubmit">
      <div class="register-logo">
        <img src="@/assets/images/LOGO@2x.png" alt="">
      </div>
      <p class="phone-num">{{ $t('quickLogin') }}</p>
      <van-field
        v-for="item of loginFormList"
        :key="item.key"
        v-model="loginForm[item.key]"
        v-bind="item.bind"
        :name="item.key"
        class="van-field"
        :placeholder="item.placeholder"
      >
        <template v-slot:label>
          <split-label :label="item.label" />
        </template>
      </van-field>
      <van-field
        v-model="loginForm['vertifyCode']"
        :placeholder="this.$t('verificationCode')"
      >
        <template v-slot:label>
          <split-label :label="$t('verificationCode')" />
        </template>
        <template #button>
          <div class="get-code">
            <van-button
              plain
              native-type="button"
              color="#3F92DD"
              @click="getCodeCount > 0 ? null : handleGetCode(true)"
            >{{ $t('gain') }}{{ getCodeCount > 0 ? '(' + getCodeCount + ')' : $t('verificationCode') }}</van-button>
          </div>
        </template>
      </van-field>
      <p class="go-register" @click="$router.push('/register')">注册账号</p>
      <dr-agreement v-model="loginForm.agreement" margin-top="53.5px" />
      <div class="button-enroll">
        <van-button
          :color="loginForm.agreement ? 'rgba(0,91,172,1)' : 'rgba(198,203,208,1)'"
          :disabled="!loginForm.agreement"
          round
          block
          type="info"
          native-type="submit"
          class="button-enroll-button"
        >{{ $t('login') }}</van-button>
      </div>
    </van-form>
  </div>

</template>

<script>
import DrAgreement from '@/components/Agreement'
import { PHONE_REG, BASE_REQUIRED } from '@/utils/validate'
import CodeMixin from '@/mixin/code'
import { USER_LOGIN_TYPE } from '@/api/constants'
import { setLocalStore } from '@/utils'

export default {
  name: 'Login',
  components: { DrAgreement },
  mixins: [CodeMixin],
  data() {
    return {
      // 登录列表
      loginFormList: [
        {
          placeholder: '手机号码',
          key: 'phonenum',
          label: '手机号码',
          bind: {
            maxlength: 11,
            required: true,
            type: 'tel',
            rules: [
              ...BASE_REQUIRED
            ]
          }
        }
      ],
      // 登录信息列表
      loginForm: {
        agreement: true,
        phonenum: '',
        vertifyCode: ''
      }
    }
  },
  methods: {
    // 获取验证码
    handleGetLoginCOdeClick() {
      this.$api('BASE_SEND_VERIFY_H5', {
        phonenum: this.loginForm['phonenum'],
        vertifyCodeType: 'LOGIN'
      })
    },
    async handleGetCode(submit) {
      const phone = this.loginForm['phonenum']
      if (phone && PHONE_REG.test(phone)) {
        // 模拟请求
        this.handleGetLoginCOdeClick()
        submit && await setTimeout(() => {
          this.handleCountDownAction()
        }, 1000)
        return true
      }
      this.$toast.fail('请输入正确手机号码')
    },
    handleLoginSubmit() {
      // 校验手机号
      // 1. 使用vant自带的校验 class会将input向上顶 影响体验
      // 2. 使用一个方法保证方法的复用性
      // 3. disabled会重写背景色
      this.handleGetCode()
        .then((res) => {
          if (res) {
            const { phonenum, vertifyCode } = this.loginForm
            if (!vertifyCode) {
              this.$toast.fail('请输入验证码')
              return
            }
            // 点对点的接口直接写 不用封装到common-api
            // 复用性强的封装调用
            this.$api('USER_LOGIN_H5', {
              phonenum,
              vertifyCode,
              userLoginType: USER_LOGIN_TYPE[0]
            }).then((res) => {
              if (res.code === 200) {
                setLocalStore('userInfo', res.result)
                this.$router.replace({
                  name: 'HomePage'
                })
                return
              }
              this.$toast.fail(res.msg)
            })
          }
        })
    }
  }
}
</script>

<style lang="scss"  scoped>
@import '~@/styles/base/form.scss';
  .login{
    ::v-deep .van-cell {
      background-color: rgba(0, 0, 0, 0);
    }
    ::v-deep .van-button--plain {
      background-color: rgba(0, 0, 0, 0);
    }
    .back-ground{
      width: 100%;
      height: 100%;
      z-index: -999;
      position: absolute;
    }
    .login-form {
      padding: 23.5px;
      .go-register {
        font-size: 15px;
        color: #3f92dd;
        margin-left: 10px;
        margin-top: 20px;
      }
      .register-logo{
        display: flex;
        justify-content: center;
        img {
          width: 171px;
          height: 22px;
          margin-top: 29.5px;
        }
      }
    }
    .button-enroll-button {
      width: 326px;
      margin: 0 auto;
      outline: none;
      border: none;
    }
    button {
      border: none;
      outline: none;
    }
    .button-enroll {
      margin-top: 16px;
    }
    .phone-num {
      font-size: 15px;
      margin-top: 45px;
      font-weight: Bold;
      margin-bottom: 18px;
    }
  }
</style>
